
import Advertisement from "@/components/Advertisement";
import ClientHead from "@/components/main/core/ClientHead";
import RedSection from "@/components/main/core/RedSection";
import RedHeadBox from "@/components/main/core/RedHeadBox";
import CheckBox from "@/components/main/core/CheckBox";
import BlogPost from "@/components/main/blog/BlogPost";
import RedSearchNow from "@/components/main/core/RedSearchNow";

import 'epic-spinners/dist/lib/epic-spinners.min.css'
import {BreedingRhombusSpinner } from 'epic-spinners/dist/lib/epic-spinners.min.js'

import Paginate from 'vuejs-paginate/src/components/Paginate.vue';
const StarRating = process.client ? require('vue-star-rating').default : undefined
import CtaSteps from "@/components/main/steps/CtaSteps";

export default {

  head() {
    const title = `${this.categoryPostsData ? this.upperCaseTitle : '' } ᐈ Read in blog iFindCheaters`;
    const description = this.currentCategory ? this.currentCategory.seo_description : '';
    const ogTitle = `${this.currentCategory ? this.currentCategory.seo_title : '' } ᐈ Read in blog iFindCheaters`;

    return {
      title: title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: title
        },
        {
          hid: 'description',
          name: 'description',
          content: description
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: ogTitle
        }
      ],
      link: [
        {
          hid: "canonical",
          rel: "canonical",
          href: `https://ifindcheaters.com/blog/category/${this.$route.params.slug}/`,
          href: this.$route.query.page || this.$route.query.page >= 1 ? `https://ifindcheaters.com/blog/category/${this.$route.params.slug}/?page=${this.$route.query.page}` : `https://ifindcheaters.com/blog/category/${this.$route.params.slug}/`,
        },
      ],
    }
  },

  name: "slug",
  layout: 'clientLayout',
  mixins: [],
  components: {Advertisement, ClientHead, RedSection, RedHeadBox, CheckBox, BlogPost, RedSearchNow, BreedingRhombusSpinner, Paginate, StarRating, CtaSteps},
  data() {
    return {
      categoryPostsData: null,
      popularPostsData: null,
      tagsData: null,
      categoriesData: null,
      showMore: false,
    }
  },
  computed: {
    upperCaseTitle() {
      return this.$route.params.slug.split('-').map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()).join(' ');
    },
    currentPage() {
      return this.$route.query.page ? parseInt(this.$route.query.page) : 1
    },
    currentCategory() {
      return this.categoriesData?.data?.find(category => category.slug === this.$route.params.slug);
    },
  },

  async fetch() {
    const page = this.$route.query.page || 1;
    try {
      const [categoryPostsResponse, popularPostsResponse, tagsResponse, categoriesResponse] = await Promise.all([
        this.$axios.get(`${process.env.BLOG_API_BASE_URL}/api/category/${this.$route.params.slug}/?page=${page}`),
        this.$axios.get(`${process.env.BLOG_API_BASE_URL}/api/posts/popular`),
        this.$axios.get(`${process.env.BLOG_API_BASE_URL}/api/tags`),
        this.$axios.get(`${process.env.BLOG_API_BASE_URL}/api/categories`),
      ]);

      this.categoriesData = categoriesResponse.data;
      this.categoryPostsData = categoryPostsResponse.data;
      this.popularPostsData = popularPostsResponse.data;
      this.tagsData = tagsResponse.data;
    } catch (error) {
      console.error('Error:', error);
    }
  },

  methods: {
    pageChange(page) {
      let self = this
      this.$axios
        .get(`${process.env.BLOG_API_BASE_URL}/api/category/${this.$route.params.slug}/?page=${page}`)
        .then(response => {
          self.categoryPostsData = response.data
          self.$router.push(page === 1 ? `/blog/category/${self.$route.params.slug}/` : `/blog/category/${self.$route.params.slug}/?page=${page}`);
        })
        .catch(function (error) {
          console.log('error: ' + error);
        });
    },
    paginatePage(pageNum) {
      this.pageChange(pageNum)
    },
    toggleShowMore() {
      this.showMore = !this.showMore;
    },
  }
}
